import { render, staticRenderFns } from "./CODCertification.vue?vue&type=template&id=692325b6&scoped=true"
import script from "./CODCertification.vue?vue&type=script&lang=js"
export * from "./CODCertification.vue?vue&type=script&lang=js"
import style0 from "./CODCertification.vue?vue&type=style&index=0&id=692325b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692325b6",
  null
  
)

export default component.exports